export class NewsletterSubscription {
    constructor() {
        this.genresLoaded = false;
        this.errorContainer = $('#alert-danger');
        this.errorContent = $('#alert-danger .content');
        this.successContainer = $('#alert-success');
        this.successContent = $('#alert-success .content');
    }

    init() {
        $(document).ready(() => {
            this.initGenreSelect();
            this.initFormSubmit();
        });
    }

    initGenreSelect() {
        const apiUrl = window.localVariables.genresApiUrl;

        if (!apiUrl) {
            console.error('Nie można pobrać gatunków muzycznych');
            return;
        }

        $('#genre-select').select2({
            language: window.localVariables.currentLanguage,
            ajax: {
                url: apiUrl,
                success: function (data) {
                    this.genresLoaded = true;
                },
                processResults: function (data) {
                    let genres = [];
                    Object.entries(data.genres).forEach(([id, name]) => {
                        genres.push({
                            id: id,
                            text: name
                        });
                    });

                    return {
                        results: genres
                    };
                }
            }
        });
    }

    initFormSubmit() {
        $('#newsletter-form').on('submit', (e) => {
            e.preventDefault();
            this.hideAlerts();
            this.submitForm();
        });
    }

    hideAlerts() {
        if (this.errorContainer) {
            this.errorContainer.slideUp();
        }

        if (this.successContainer) {
            this.successContainer.slideUp();
        }
    }

    submitForm() {
        let $this = $('#newsletter-form');
        let formData = $this.serialize();

        $.ajax({
            url: $this.attr('action'),
            method: 'POST',
            data: formData,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: (response) => {
                console.log(response);

                if (response.success) {
                    this.handleFormSuccessMessage([response.success]);
                }

                $('#newsletter-form')[0].reset();
                $('#newsletter-form select').val(null).trigger('change');
            },
            error: (xhr) => {
                this.handleErrors(xhr);
            }
        });
    }

    handleErrors(response) {
        if (response.status === 422) {
            this.handleFormErrors(response.responseJSON);

            return;
        }

        if (typeof response.responseJSON.error !== 'undefined') {
            this.handleFormErrors([response.responseJSON.error]);

            return;
        }

        this.handleFormErrors(['Wystąpił błąd przy zapisie do newslettera. Prosimy spróbować później.']);
    }

    handleFormErrors(errors) {
        if (typeof this.errorContainer == undefined || typeof this.errorContent == undefined) {
            return;
        }

        this.errorContainer.slideDown();
        this.errorContent.empty();

        $.each(errors, (key, value) => {
            this.errorContent.append(`<p>${value}</p>`);
        });
    }

    handleFormSuccessMessage(errors) {
        if (typeof this.successContainer == undefined || typeof this.successContent == undefined) {
            return;
        }

        this.successContainer.slideDown();
        this.successContent.empty();

        $.each(errors, (key, value) => {
            this.successContent.append(`<p>${value}</p>`);
        });
    }
}